import { localStorageUtils } from '@skin-seoul/utils';

const DEVICE_ID_KEY = 'device_id';

export function getDeviceId(): string {
  const deviceId = localStorageUtils.getItem<string>(DEVICE_ID_KEY, '');
  return deviceId;
}
